/* menu-halo: ripple per il pulsante menu mobile, indipendente dalla galleria */
(() => {
  // ===== CONFIG =====
  const BTN_SELECTOR =
    'button.btn--icon.mobile-nav-toggle.tap-target[aria-controls="MobileNavigationDrawer"]';
  const MOBILE_BODY_CLASS = "custom-mobile-view-active";

  // URL che DEVONO usare gli stessi tempi della galleria (2.5s, poi ogni 8s)
  const FORCE_URLS = ["/404", "/policies/legal-notice"];

  // URL da ESCLUDERE dal fallback dei 20s (nessun ripple su queste pagine)
  const EXCLUDE_URLS = ["/policies/terms-of-service"];

  // Tempi
  const FIRST_FORCED = 2500, REPEAT_FORCED = 8000;
  const FIRST_FALLBACK = 20000, REPEAT_FALLBACK = 8000;

  // Stile coerente con la galleria
  const RIPPLE_MIN = 2, RIPPLE_MAX = 3;
  const DURATION_BASE = 950, STAGGER = 140;
  const RING_BORDER = 2, RING_OUTSET = 8; // px “fuori” dal bottone
  const RING_COLOR = "#e10600";
  const SCALE_END = 3.6;
  const MAX_REPEATS = 9999;

  // Fallback: arma SOLO dopo prima interazione (scroll/zoom/tap)
  const ARM_ON_LOAD = false;

  // Limiti/cooldown per il fallback (usati nel loop)
  const FALLBACK_COOLDOWN_MS = 60000;
  const cooldownUntil = new WeakMap(); // btn -> timestamp fino a quando non ripartire

  // —— Stato per "inattività" e memoria "ho capito dov'è il menu" ——
  const pendingMap = new WeakMap(); // btn -> { pending, removeGuards }
  const LEARN_KEY = "menuHaloLearned"; // persiste nella sessione del tab

  // Considera "mobile" quando è presente il template del drawer mobile
  const MOBILE_TEMPLATE_SELECTOR = ".mobile-navigation-drawer-template";
  function isMobileActive() {
    return !!document.querySelector(MOBILE_TEMPLATE_SELECTOR)
        || document.body.classList.contains(MOBILE_BODY_CLASS)
        || matchMedia("(max-width: 768px)").matches;
  }

  // Hook opzionale per azzerare la memoria via query
  try {
    if (new URLSearchParams(location.search).get("resetMenuHalo") === "1") {
      sessionStorage.removeItem("menuHaloLearned");
    }
  } catch (e) {}

  function isLearned() {
    try { return sessionStorage.getItem(LEARN_KEY) === "1"; }
    catch (e) { return false; }
  }
  function markLearned() {
    try { sessionStorage.setItem(LEARN_KEY, "1"); }
    catch (e) {}
  }

  // Rispetta prefers-reduced-motion
  if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  // ===== UTILS =====
  const normPath = () => (location.pathname || "").toLowerCase().replace(/\/+$/, "");
  const matchesUrl = (list) => list.some((u) => normPath().startsWith(String(u).toLowerCase().replace(/\/+$/, "")));

  function findVisibleButton() {
    const nodes = document.querySelectorAll(BTN_SELECTOR);
    for (const el of nodes) {
      const cs = getComputedStyle(el);
      if (cs.display === "none" || cs.visibility === "hidden" || +cs.opacity === 0) continue;
      const r = el.getBoundingClientRect();
      const onScreen = r.width > 0 && r.height > 0 && r.bottom > 0 && r.right > 0 && r.top < innerHeight && r.left < innerWidth;
      if (onScreen) return el;
    }
    return null;
  }

  function isMenuOpen(btn) {
    if (!btn) return false;
    if (btn.getAttribute("aria-expanded") === "true") return true;
    const id = btn.getAttribute("aria-controls");
    const d = id && document.getElementById(id);
    if (d) {
      const cs = getComputedStyle(d);
      if (cs.display !== "none" && cs.visibility !== "hidden" && +cs.opacity > 0) return true;
      if (d.hasAttribute("open") || d.classList.contains("is-open") || d.classList.contains("open")) return true;
    }
    return false;
  }

  // ===== “PORTALE” OVERLAY (sempre sopra tutto) =====
  let portal = null;
  const Z_TOP = 2147483647; // z-index altissimo

  function ensurePortalFor(btn) {
    if (!portal) {
      portal = document.createElement("span");
      portal.className = "close-halo";
      portal.dataset.halo = "menu-portal";
      Object.assign(portal.style, {
        position: "fixed",
        pointerEvents: "none",
        zIndex: String(Z_TOP),
        borderRadius: "999px",
        display: "block",
        overflow: "visible",
      });
      document.body.appendChild(portal);
      // Crea i ring
      for (let i = 0; i < RIPPLE_MAX; i++) {
        const ring = document.createElement("span");
        ring.className = "halo-ring";
        Object.assign(ring.style, {
          position: "absolute",
          inset: "0",
          border: `${RING_BORDER}px solid ${RING_COLOR}`,
          borderRadius: "999px",
          opacity: "0",
          transform: "scale(0.6)",
        });
        portal.appendChild(ring);
      }
    }
    repositionPortal(btn);
    return portal;
  }

  function repositionPortal(btn) {
    if (!portal || !btn) return;
    const r = btn.getBoundingClientRect();
    Object.assign(portal.style, {
      left: (r.left - RING_OUTSET) + "px",
      top: (r.top - RING_OUTSET) + "px",
      width: (r.width + RING_OUTSET * 2) + "px",
      height: (r.height + RING_OUTSET * 2) + "px",
    });
  }

  function animateOnce(btn) {
    ensurePortalFor(btn);
    const rings = [...portal.querySelectorAll(".halo-ring")];
    const count = Math.floor(Math.random() * (RIPPLE_MAX - RIPPLE_MIN + 1)) + RIPPLE_MIN;

    rings.forEach((ring, i) => {
      ring.getAnimations().forEach((a) => a.cancel());
      const active = i < count;
      ring.style.opacity = active ? "1" : "0";
      ring.style.transform = active ? "scale(0.6)" : `scale(${SCALE_END})`;
      if (!active) return;

      const delay = i * STAGGER;
      const anim = ring.animate(
        [
          { transform: "scale(0.6)", opacity: 0.9 },
          { transform: `scale(${SCALE_END})`, opacity: 0 },
        ],
        { duration: DURATION_BASE + i * 180, easing: "ease-out", delay, fill: "forwards" }
      );
      anim.addEventListener("finish", () => {
        ring.style.opacity = "0";
        ring.style.transform = `scale(${SCALE_END})`;
      });
    });
  }

  function turnOffRings() {
    if (!portal) return;
    portal.querySelectorAll(".halo-ring").forEach((r) => {
      r.getAnimations().forEach((a) => a.cancel());
      r.style.opacity = "0";
      r.style.transform = `scale(${SCALE_END})`;
    });
  }

  // Attacca listener "produttivi" e restituisce un remover
  function attachProductiveInteractivityGuards(btn, onActivity) {
    const cap = true;
    const handler = (e) => {
      if (!e.isTrusted) return;
      if (btn && (e.target === btn || btn.contains(e.target))) return;
      const sel = 'a, button, [role="button"], input, select, textarea, label, ' +
                  '[aria-controls], [aria-expanded], [data-action], [data-drawer], [data-toggle], ' +
                  'details, summary, form';
      const interactive = e.target.closest?.(sel);
      const productive = interactive || ['submit','change','input','focusin','keydown'].includes(e.type);
      if (productive) onActivity(e);
    };

    document.addEventListener('click', handler, cap);
    document.addEventListener('pointerdown', handler, cap);
    document.addEventListener('touchstart', handler, cap);
    document.addEventListener('keydown', handler, cap);
    document.addEventListener('focusin', handler, cap);
    document.addEventListener('input', handler, cap);
    document.addEventListener('change', handler, cap);
    document.addEventListener('submit', handler, cap);

    return () => {
      document.removeEventListener('click', handler, cap);
      document.removeEventListener('pointerdown', handler, cap);
      document.removeEventListener('touchstart', handler, cap);
      document.removeEventListener('keydown', handler, cap);
      document.removeEventListener('focusin', handler, cap);
      document.removeEventListener('input', handler, cap);
      document.removeEventListener('change', handler, cap);
      document.removeEventListener('submit', handler, cap);
    };
  }

  // ===== TIMER/OBSERVER =====
  const timers = new WeakMap(); // btn -> { first, loop, moBtn, removeActiveGuards }
  let boundScroll = null, boundResize = null, boundVV = null;

  function attachRepositioners(btn) {
    boundScroll = () => repositionPortal(btn);
    boundResize = () => repositionPortal(btn);
    boundVV = () => repositionPortal(btn);
    window.addEventListener("scroll", boundScroll, { passive: true });
    window.addEventListener("resize", boundResize);
    window.visualViewport?.addEventListener("resize", boundVV, { passive: true });
  }
  function detachRepositioners() {
    if (boundScroll) window.removeEventListener("scroll", boundScroll, { passive: true });
    if (boundResize) window.removeEventListener("resize", boundResize);
    if (boundVV) window.visualViewport?.removeEventListener("resize", boundVV);
    boundScroll = boundResize = boundVV = null;
  }

  function stop(btn) {
    const t = btn && timers.get(btn);
    if (t) {
      clearTimeout(t.first);
      clearInterval(t.loop);
      t.moBtn && t.moBtn.disconnect();
      t.removeActiveGuards && t.removeActiveGuards();
      timers.delete(btn);
    }
    const p = btn && pendingMap.get(btn);
    if (p) {
      clearTimeout(p.pending);
      p.removeGuards?.();
      pendingMap.delete(btn);
    }
    turnOffRings();
    detachRepositioners();
  }

  // Blocca solo se un overlay/modal interseca il bottone (non i banner/cookie non sovrapposti)
  function isBlockingOverlay(targetBtn) {
    if (!targetBtn) return false;
    const br = targetBtn.getBoundingClientRect();
    const overlays = document.querySelectorAll('[aria-modal="true"], dialog[open], .modal[open], .modal.is-open');
    for (const el of overlays) {
      const cs = getComputedStyle(el);
      if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) === 0) continue;
      const r = el.getBoundingClientRect();
      const overlap = !(r.right < br.left || r.left > br.right || r.bottom < br.top || r.top > br.bottom);
      if (overlap) return true;
    }
    return false;
  }

  function start(btn, firstDelay, repeatDelay, maxRepeats = MAX_REPEATS) {
    if (!btn || timers.get(btn) || isMenuOpen(btn)) return;
    ensurePortalFor(btn);
    attachRepositioners(btn);

    const first = setTimeout(() => {
      if (!document.body.contains(btn) || isMenuOpen(btn) || isBlockingOverlay(btn)) { stop(btn); return; }

      animateOnce(btn);
      let repeats = 1;

      const loop = setInterval(() => {
        const b = findVisibleButton();
        if (!b || isMenuOpen(b) || isBlockingOverlay(b) || repeats >= maxRepeats) {
          if (maxRepeats !== MAX_REPEATS) {
            cooldownUntil.set(btn, Date.now() + FALLBACK_COOLDOWN_MS);
          }
          stop(btn);
          return;
        }
        repositionPortal(b);
        animateOnce(b);
        repeats++;
      }, repeatDelay);

      const forced = matchesUrl(FORCE_URLS);
      const removeActiveGuards = attachProductiveInteractivityGuards(btn, () => {
        if (forced) return;                 // su /404 non interrompere
        stop(btn);                           // spegne subito il loop
        if (!isLearned()) beginInactivityPhase(btn); // rientra in inattività 20s
      });

      const moBtn = new MutationObserver(() => {
        if (isMenuOpen(btn)) { markLearned(); stop(btn); }
      });
      moBtn.observe(btn, { attributes: true, attributeFilter: ['aria-expanded','class'] });

      timers.set(btn, { first: null, loop, moBtn, removeActiveGuards });
    }, firstDelay);

    // stop definitivo anche su tap/click diretto del menu
    const onOpen = () => { markLearned(); stop(btn); };
    btn.addEventListener("click", onOpen, { once: true, passive: true });
    btn.addEventListener("touchstart", onOpen, { once: true, passive: true });

    timers.set(btn, { first, loop: null, moBtn: null, removeActiveGuards: null });
  }

  // Avvia il "conto alla rovescia" di inattività (20s) e resetta ad ogni interazione produttiva
  function beginInactivityPhase(btn) {
    if (pendingMap.get(btn)) return; // già in attesa

    const state = { pending: null, removeGuards: null };
    pendingMap.set(btn, state);

    const reset = () => {
      clearTimeout(state.pending);
      state.pending = null;
    };

    const schedule = () => {
      reset();
      state.pending = setTimeout(() => {
        if (!btn || !document.body.contains(btn)) return;
        if (isMenuOpen(btn)) { reset(); return; }
        start(btn, 0, REPEAT_FALLBACK); // partenza immediata allo scadere dei 20s
        reset();
      }, FIRST_FALLBACK);
    };

    const activity = (e) => {
      if (!e.isTrusted) return;
      if (btn && (e.target === btn || btn.contains(e.target))) return;
      const sel = 'a, button, [role="button"], input, select, textarea, label, [aria-controls], [aria-expanded], [data-action], [data-drawer], details, summary';
      const isInteractive = e.target.closest?.(sel);
      const productive = isInteractive || ['submit','change','input','focusin','keydown'].includes(e.type);
      if (productive) schedule(); // ricomincia i 20s
    };

    const addGuards = () => {
      const cap = true; // capture
      document.addEventListener('click',       activity, cap);
      document.addEventListener('pointerdown', activity, cap);
      document.addEventListener('keydown',     activity, cap);
      document.addEventListener('focusin',     activity, cap);
      document.addEventListener('input',       activity, cap);
      document.addEventListener('change',      activity, cap);
      document.addEventListener('submit',      activity, cap);
      state.removeGuards = () => {
        document.removeEventListener('click',       activity, cap);
        document.removeEventListener('pointerdown', activity, cap);
        document.removeEventListener('keydown',     activity, cap);
        document.removeEventListener('focusin',     activity, cap);
        document.removeEventListener('input',       activity, cap);
        document.removeEventListener('change',      activity, cap);
        document.removeEventListener('submit',      activity, cap);
      };
    };

    addGuards();
    schedule();
  }

  // Arma una sola volta: al primo scroll/zoom/tap generico entra in "inattività 20s"
  function armFallbackTriggersOnce(btn) {
    const opt = { passive: true, once: true };
    const onScroll = () => beginInactivityPhase(btn);
    const onVV = () => {
      const s = window.visualViewport?.scale || 1;
      if (Math.abs(s - 1) > 0.02) beginInactivityPhase(btn);
    };
    const onTap = (e) => {
      if (btn && (e.target === btn || btn.contains(e.target))) return; // non armiamo se tocca il menu
      beginInactivityPhase(btn);
    };

    window.addEventListener("scroll", onScroll, opt);
    window.visualViewport?.addEventListener("resize", onVV, opt);
    if ("PointerEvent" in window) {
      document.addEventListener("pointerdown", onTap, { passive: true, once: true });
    } else {
      document.addEventListener("touchstart", onTap, { passive: true, once: true });
      document.addEventListener("mousedown",  onTap, { passive: true, once: true });
    }
  }

  // ===== INNESCO =====
  function maybeStart() {
    const btn = findVisibleButton();
    if (!btn) { stop(null); return; }

    // 1) FORCE_URLS (es. /404): parte subito come galleria
    if (matchesUrl(FORCE_URLS)) {
      if (!timers.get(btn)) start(btn, FIRST_FORCED, REPEAT_FORCED);
      return;
    }

    // 2) Stop definitivo già memorizzato?
    if (isLearned()) { stop(btn); return; }

    // 3) Gating "mobile"
    if (!isMobileActive()) { stop(btn); return; }

    // 4) EXCLUDE_URLS: niente fallback
    if (matchesUrl(EXCLUDE_URLS)) { stop(btn); return; }

    // 5) Fallback: arma SOLO al primo scroll/zoom/tap
    if (!timers.get(btn) && !pendingMap.get(btn)) {
      if (ARM_ON_LOAD) beginInactivityPhase(btn); else armFallbackTriggersOnce(btn);
    }
  }

  // Osserva arrivo bottone e toggle della classe mobile sul body
  const bodyObs = new MutationObserver(maybeStart);
  bodyObs.observe(document.body, { attributes: true, attributeFilter: ["class"] });

  const domObs = new MutationObserver(maybeStart);
  domObs.observe(document.documentElement, { childList: true, subtree: true });

  // Kick
  maybeStart();

  // API manuale utile in caso di test
  window.__menuHalo = { start, stop, _ensurePortalFor: ensurePortalFor };
})();
